import { defineCustomElement } from 'vue';
import scrollToTopStyles from './css/scroll-to-top.css?inline';
import GcsaSiteFooterCe from './components/GcsaSiteFooter.ce.vue';
import GcsaLogoCe from './components/GcsaLogo.ce.vue';
import GcsaMobileSidebarCe from './components/GcsaMobileSidebar.ce.vue';
import GcsaScrollToTopCe from './components/GcsaScrollToTop.ce.vue';

/**
 * Cross-framework entry (Nuxt 2 / Next.js / React / plain HTML).
 * Vue runtime is bundled into this build — host apps do NOT need Vue.
 *
 *   import 'gcsa-ui/elements'
 *   // registers <gcsa-site-footer>, <gcsa-logo>, <gcsa-mobile-sidebar>, <gcsa-scroll-to-top>
 */

export const GcsaSiteFooterElement = defineCustomElement(GcsaSiteFooterCe);
export const GcsaLogoElement = defineCustomElement(GcsaLogoCe);
export const GcsaMobileSidebarElement = defineCustomElement(GcsaMobileSidebarCe);
export const GcsaScrollToTopElement = defineCustomElement(GcsaScrollToTopCe);

export type GcsaUiElementTag =
  | 'gcsa-site-footer'
  | 'gcsa-logo'
  | 'gcsa-mobile-sidebar'
  | 'gcsa-scroll-to-top';

const SCROLL_TO_TOP_STYLE_ID = 'gcsa-ui-ui-scroll-to-top-styles';

/** Teleport 到 body 的按钮不走 Shadow DOM，需注入全局样式 */
function ensureScrollToTopStyles() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(SCROLL_TO_TOP_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = SCROLL_TO_TOP_STYLE_ID;
  style.textContent = scrollToTopStyles;
  document.head.appendChild(style);
}

export function registerGcsaUiElements(
  registry: Pick<CustomElementRegistry, 'define' | 'get'> = customElements
): void {
  if (typeof window === 'undefined') return;
  if (!registry.get('gcsa-site-footer')) {
    registry.define('gcsa-site-footer', GcsaSiteFooterElement);
  }
  if (!registry.get('gcsa-logo')) {
    registry.define('gcsa-logo', GcsaLogoElement);
  }
  if (!registry.get('gcsa-mobile-sidebar')) {
    registry.define('gcsa-mobile-sidebar', GcsaMobileSidebarElement);
  }
  if (!registry.get('gcsa-scroll-to-top')) {
    ensureScrollToTopStyles();
    registry.define('gcsa-scroll-to-top', GcsaScrollToTopElement);
  }
}

registerGcsaUiElements();

export default registerGcsaUiElements;
